import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import useDevice from '@/hooks/useDevice';

import styles from './HistoryAddressHeader.module.sass';

const HistoryAddressHeader = () => {
  const { t } = useTranslation();
  const { isMobile } = useDevice();

  const rowClasses = cx(styles.entry, {
    [styles.row]: true,
  });

  if (isMobile) return null;

  return (
    <div className={rowClasses}>
      <div className={`${styles.col} ${styles['col--icon']}`} />
      <div className={`${styles.col} ${styles['col--name']}`}>
        {t('translation.monitoring_table_name')}
      </div>
      <div className={`${styles.col} ${styles['col--risky']}`}>
        {t('translation.monitoring_table_risky')}
      </div>
      <div className={`${styles.col} ${styles['col--blacklisted']}`}>
        {t('translation.monitoring_table_blacklisted')}
      </div>
      <div className={`${styles.col} ${styles['col--next-check']}`}>
        {t('translation.monitoring_table_next_check')}
      </div>
      <div className={`${styles.col} ${styles['col--status']}`}>
        {t('translation.monitoring_table_status')}
      </div>
      <div className={`${styles.col} ${styles['col--actions']}`}>
        <div className={styles.col} />
        <div className={styles.col} />
      </div>
    </div>
  );
};

export default HistoryAddressHeader;
